<template>
<div id="ap_bancos" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Identificador de Bancos para conectividad (Banxico)" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>

                            <exportar-excel :data="datafiltered" :exportFields="bancos.camposexcel" name="Bancos.xlsx" >
                                <v-btn fab dark x-small color="success" title="Exportar Registros" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="bancos.camposLayout" :exportFields="bancos.encabezadoLayout" name="Layout Bancos.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>
                        &nbsp;
                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >
                                            {{
                        update ? "edit" : "add"
                        }}
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>
                                                {{ update ? "Actualizar" : "Nuevo" }} Banco
                                            </strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-row>
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-text-field label="Clave" type="text" v-model="model.clave" :rules="[rules.required, verificaLongitud]" @keyup="soloNumeros('clave')" maxlength="5" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="6" md="6" lg="6" >
                                                    <v-text-field label="Nombre Banco" type="text" v-model="model.nombre" maxlength="350" :rules="[rules.required]" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="3" md="3" lg="3" >
                                                    <v-text-field label="Nombre Corto" type="text" @input="model.nombre_corto = model.nombre_corto.toUpperCase()" v-model="model.nombre_corto" 
                                                        :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-col>                                                
                                            </v-row>                                                                                
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon>Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-client-table ref="principalTable" :data="bancos.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_banco)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_banco)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>

        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
    components: {
        "v-menu-lateral-apendice": menuLateral,
        "v-power-titulo": powerTitulo
    },
    mounted() {},

    data: () => ({
        url_active: location.href,        
        editable: true,             
        title: "Bancos",        
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apéndices",
                disabled: true,
                to: ""
            }
        ],
        columns: [            
            "clave",
            "nombre",            
            "nombre_corto",                   
            "actions"
        ],
        options: {            
            headings: {
                "clave":"Clave",
                "nombre":"Nombre Banco",  
                "nombre_corto":"Nombre Corto",                                   
                actions: "Operaciones"
            },            
        },
        URL: "",
        
        loading: false,
        modal: false,
        update: false,        
        model: {
            id_banco: 0,
            clave:"",
            nombre:"",
            nombre_corto:"",
            user_updated:"",
            
        },
        rules: {
            required: v => !!v || "Este campo es requerido",            
        },
        bancos: {
            selected: [],
            camposexcel: {
                Clave: "clave",
                "Nombre Banco":"nombre",
                "Nombre Corto": "nombre_corto",                             
            },
    
            items: [],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {                
                clave: "clave",
                nombre: "nombre",
                nombre_corto: "nombre_corto",                             
            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{                
                clave: "[clave - 5 dígitos]",
                nombre: "[Nombre Banco]",
                nombre_corto: "[Nombre Corto - 100 caracteres]",                            
            }]
        },       
        camposObligatorios: {
            "clave": "Clave",
            "nombre": "Nombre Banco",
            "nombre_corto": "Nombre Corto",            
        },

    }),
    computed: {
        datafiltered() {
            if (this.$refs.principalTable != null) {                
                return this.$refs.principalTable.allFilteredData;
            } else {
                return this.bancos.items;
            }
        }
    },
    methods: {
        verificaLongitud: function(value){ 
            if (value.toString().length != 5 ){
                return "Deben ser 5 dígitos";
            } 
            return true;
        },        
        verificaLongitud3: function(value){ 
            if (value.toString().length != 3 ){
                return "Deben ser 3 caracteres";
            } 
            return true;
        },
        soloNumeros: function(campo){ 
            const pattern = /^[\d]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloNumeros(campo);                
            }                      
        },
        soloNumerosLetras: function(campo){ 
            const pattern = /^[\a-zA-Z0-9]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloNumerosLetras(campo);                
            }             
        },
        soloLetras: function(campo){ 
            const pattern = /^[\a-zA-Z]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloLetras(campo);                
            }             
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Banco";
                this.update = false;
            } else {
                this.title = "Actualizar Banco";
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }            
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_banco + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        try {
                            var errores = "";
                            if (typeof error.response.data != "undefined") {
                                Object.keys(error.response.data).forEach(function (key) {
                                    for (var k in error.response.data[key]) {
                                        errores += key + ": " + error.response.data[key][k];
                                        errores += "<br>";
                                    }
                                });
                            }
                                
                            this.$swal({
                                position: "center",
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al guardar los datos",
                                footer: errores,
                                //showConfirmButton: false,
                            });
                            //console.log(err);
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                            this.modal = false;
                        } catch (error) {
                            console.log(error);
                        }
                        
                    });
            }
        },
        
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.bancos.items = res.data;
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },
       
        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;                    
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
                }
                    
            });
        }, //delete
        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = "";
            const pattern = /^[\d]*$/;
            const patternLetra = /^[\a-zA-Z]*$/;
            const patternLetraNumero = /^[\a-zA-Z0-9]*$/;
            try {
                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");                    
                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {
                        if ( results[k]['clave'].toString().replace("-","").length != 5 ){
                            errores++;
                            erroresText += "- Clave \"" + results[k]["clave"] + "\" debe ser de 5 dígitos <br>";
                        } else if (!pattern.test(results[k]['clave'].toString().replace("-",""))){                                                        
                            errores++;
                            erroresText += "- Clave \"" + results[k]["clave"] + "\" debe ser de 5 dígitos <br>";
                        } else {
                            results[k]['clave'] = results[k]['clave'].toString().replace("-","").padStart(5,"0");
                        }

                        if ( results[k]['nombre_corto'].toString().length > 100 ){
                            errores++;
                            erroresText += "- nombre_corto \"" + results[k]["nombre_corto"] + "\" debe ser menor de 100 caracteres <br>";
                        }
                        
                        if ( results[k]['nombre'].toString().length > 350 ){
                            errores++;
                            erroresText += "- nombre \"" + results[k]["nombre"] + "\" debe ser menor de 350 caracteres <br>";
                        }

                    }                    
                    
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText +=
                        "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return {
                    errores: errores,
                    erroresText: erroresText
                };
            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
            }
            //}); //promise
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = "";            
            try {
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText
                    });
                    
                } else {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var resultadoFinal = [];
                    for (var k in results) {
                        
                        var banco = {
                            clave: results[k]["clave"],
                            nombre: results[k]["nombre"],
                            nombre_corto: results[k]["nombre_corto"].toString().toUpperCase(),                            
                            user_updated: results[k]["user_updated"]
                        };
                        resultadoFinal.push(banco);
                    }
                    
                    axios
                        .post(this.URL + "importar_bancos/", resultadoFinal)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];                                            
                                            //Este trae 2 niveles, por eso el campo queda en la key2
                                            Object.keys(errors).forEach(function (key2) {
                                                let pos = errores.indexOf(key + ": " + errors[key2]);
                                                if (pos < 0) {
                                                    errores += key + ": " + errors[key2];
                                                    errores += "<br>";
                                                }
                                            });                                             
                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();                            
                        });
                }
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
                this.$root.$dialogLoader.hide();
            }
        },  

    }, //methods

    created: function () {
        this.URL = this.$hostname + "catalogos/bancos/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        if (this.$local_storage.get("id_cliente") > 0) {
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargar();     
    }
};
</script>